import { Button, Dialog, Dropdown, IconButton } from '@flex-design-system/fx';
import {
  DeleteIcon,
  MoreVerticalIcon,
} from '@flex-design-system/legacy-flex-icons';
import { Translation, useTranslation } from '@flex-packages/i18n';
import { useRef, useState, type ReactNode } from 'react';

interface Props {
  deleteTitle?: ReactNode;
  onItemDelete?: VoidFunction;
}
const MoreDropdown = ({ deleteTitle, onItemDelete }: Props) => {
  const { t } = useTranslation();

  const dropdownTriggerRef = useRef<HTMLButtonElement | null>(null);

  const [openMenu, setOpenMenu] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Dropdown open={openMenu} onOpenChange={setOpenMenu}>
        <Dropdown.Trigger asChild>
          <IconButton
            ref={dropdownTriggerRef}
            size="small"
            variant="ghost"
            description={t('global.icon_button.description.더_보기')}
            icon={<MoreVerticalIcon />}
          />
        </Dropdown.Trigger>
        <Dropdown.Content>
          <Dropdown.Item
            danger
            leftSlot={<DeleteIcon />}
            // Next 에서 Dropdown > Dialog 를 사용할 때 Dropdown 에서 focus 를 Dialog 로 보내주지 않는 문제를 방지한다.
            // onSelect 의 동작은 막아준다.
            // onClick event 에서 Dropdown 을 닫아준 뒤, Dialog 를 열어주도록 한다.
            // Dialog 가 닫을 때 Dropdown 의 trigger 를 focus 해주기 위해 (dropdownTriggerRef) 를 사용한다.
            // 참고: https://flex-cv82520.slack.com/archives/CS05YNN9H/p1745308546125989
            onSelect={e => e.preventDefault()}
            onClick={e => {
              e.stopPropagation();
              setOpenMenu(false);
              setOpenDialog(true);
            }}
          >
            <Dropdown.ItemTitle>
              <Translation tKey="global.삭제하기" />
            </Dropdown.ItemTitle>
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown>
      <Dialog
        open={openDialog}
        onOpenChange={setOpenDialog}
        onClose={() => {
          dropdownTriggerRef.current?.focus();
        }}
      >
        <Dialog.Content>
          <Dialog.Body>
            <Dialog.Title>{deleteTitle}</Dialog.Title>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.Cancel asChild>
              <Button variant="outline" size="large" color="gray">
                <Translation tKey="global.취소" />
              </Button>
            </Dialog.Cancel>
            <Dialog.Action
              asChild
              onClick={() => {
                onItemDelete?.();
              }}
            >
              <Button variant="solid" size="large" danger>
                <Translation tKey="global.삭제하기" />
              </Button>
            </Dialog.Action>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog>
    </>
  );
};

export { MoreDropdown };
export type { Props as MoreDropdownProps };
